import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from "@mui/material/Grid";
import Box from '@mui/material/Box';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import configurations from "config";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import MenuItem from '@mui/material/MenuItem';
import { useEffect, useState } from 'react';
import { RETURN_REQUEST } from "constants.js";
import { handleErrors } from "common.js";
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";

const ReturnRequestRejectionPopup = (props) => {
    const { returnID, setPageContent, rejectionPopupOpen, setRejectionPopupOpen } = props;
    const { t } = useTranslation();
    const baseUrl = configurations.baseUrl;
    const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
    const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
    const [isLoading, setIsLoading] = useState(false);

    const { register, handleSubmit, control, formState: { errors }, setValue, setError, reset,
    } = useForm({
        defaultValues: {
        }
    });

    useEffect(() => {
        setValue('id', returnID);
    }, []);

    const handleRejectionPopupClose = () => { setRejectionPopupOpen(false) }

    const onSubmit = async (data) => {
        setIsLoading(true)
        axios.post(baseUrl + '/return/reject', data, {
            headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
        })
            .then((response) => {
                setIsLoading(false);
                if (response.status == 200) {
                    const status = response.data.status;
                    const message = response.data.message;
                    if (status == 1) {    
                        setPageContent(response.data.data);
                        reset();
                        toast.success(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
                        setRejectionPopupOpen(false);
                    }
                    else {
                        if (message != '')
                            toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
                        if (response && response.data && response.data.errors) {
                            const errorData = response.data.errors;
                            errorData.forEach((error) => {
                                setError(error.field, {
                                    type: 'server',
                                    message: t(error.errors[0])
                                });
                            });
                        }
                    }
                }
                else {
                    toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
                }
            }).catch(error => {
                setIsLoading(false)
                handleErrors(error, t, navigate);
            });
    }

    return (
        <Dialog open={rejectionPopupOpen} onClose={handleRejectionPopupClose}>
            <DialogTitle>{t('ReturnDeclineReason')}</DialogTitle>
            <DialogContent>
                <Grid item xs={12} md={12} lg={12}>
                    <MDBox mt={3} component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4} md={4}>
                                    <MDTypography variant="body1" className="labelStyle">{t('declineReason')}
                                        <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                    </MDTypography>
                                </Grid>
                                <Grid item xs={12} sm={8} md={8}>
                                    <Controller
                                        name="declineReason"
                                        control={control}
                                        defaultValue={0}
                                        rules={{
                                            required: {
                                                value: true,
                                                message: t('declineReasonRequired')
                                            },
                                            validate: (value) => {
                                                if (value === 0) {
                                                    return t('declineReasonRequired');
                                                }
                                                return true;
                                            },
                                        }}
                                        render={({ field }) => (
                                            <MDInput
                                                select
                                                {...field}
                                                fullWidth
                                                InputProps={{
                                                    classes: { root: "select-input-styles select-padding-0" },
                                                }}
                                            >
                                                <MenuItem key={0} value={0}>{t('selectReturnDeclineReason')}</MenuItem>
                                                <MenuItem key={1} value="FINAL_SALE">{t('finalSale')}</MenuItem>
                                                <MenuItem key={2} value="RETURN_PERIOD_ENDED">{t('returnPeriodEnded')}</MenuItem>
                                                <MenuItem key={3} value="OTHER">{t('other')}</MenuItem>
                                            </MDInput>
                                        )}
                                    />
                                    {errors.declineReason && (
                                        <span className="errorMsg FloatRight">{errors.declineReason.message}</span>
                                    )}
                                </Grid>
                                <Grid item xs={12} sm={4} md={4}>
                                    <MDTypography variant="body1" className="labelStyle">{t('declineNote')}
                                    </MDTypography>
                                </Grid>
                                <Grid item xs={12} sm={8} md={8}>
                                    <Controller
                                        name="declineNote"
                                        control={control}
                                        defaultValue={''}
                                        render={({ field }) => (
                                            <MDInput
                                                type="text"
                                                multiline
                                                maxRows={8}
                                                {...field}
                                                fullWidth
                                                InputProps={{
                                                    classes: { root: "textareaHeight" },
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <DialogActions>
                                        <MDButton type="submit" variant="gradient" color="info" onClick={handleRejectionPopupClose} disabled={isLoading} disableRipple>{t('cancel')}</MDButton>
                                        <MDButton type="submit" variant="gradient" color="info" disabled={isLoading} disableRipple>{t('submit')}</MDButton>
                                        {isLoading ?
                                            <Box className='circularLoadingCommonOuter'>
                                                <CircularProgress size={30} className='circularLoadingCommon' />
                                            </Box>
                                            : null}
                                    </DialogActions>
                                </Grid>
                            </Grid>
                        </MDBox>
                    </MDBox>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

export default ReturnRequestRejectionPopup;
